<template>
  <div class="bulletin-slide-down">
    <div class="bulletin-slide-down-content" :class="{ 'hide': hide }">
      <div class="bulletin-title">
        <label class="bulletin-title-label" for="bulletin-title"> 公告</label>
      </div>
      <div class="carousel-container">
        <div ref="carousel" class="carousel">
          <!-- 循環顯示公告內容 -->
          <div v-for="(item, index ) in contents" :key="index" class="carousel-item" @click="openWebsite(item.link)">
            <label for="carousel-item" class="carousel-item-label">
              {{ item.content }}
            </label>
          </div>
        </div>
      </div>
      <img class="hide-bulletin-button" src="@/assets/right_s.png" alt="" @click="hideButtonClicked">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bulletin',
  // 監視屬性變化
  watch: {
    // 監視 announcements 的變化
    announcements(value, previousValue) {
      if (value.length > 0) {
        // 如果公告不為空且尚未啟動輪播，啟動公告輪播
        if (!this.bulletinTimeInterval) {
          this.loopAnnouncement()
        }
      } else if (value.length === 0) {
        // 如果公告為空，停止輪播並隱藏公告
        this.hideButtonClicked()
      }
      // 更新內容
      this.contents = value
    },
    // 監視 hide 的變化
    hide(value, previousValue) {
      // 可以根據需要添加額外的處理
    }
  },
  // 父組件傳遞的屬性
  props: {
    hide: {
      type: Boolean,
      default: false
    },
    announcements: {
      type: Array,
      default: () => []
    },
  },
  mounted() {
    // 組件掛載時可以執行初始化操作
  },
  data() {
    return {
      itemHeight: 60, // 單個公告項目的高度
      currentIndex: 0, // 當前顯示的公告索引
      carouselIntervalTime: 4000, // 輪播間隔時間（毫秒）
      contents: [], // 公告內容
      bulletinTimeInterval: null // 輪播定時器
    }
  },
  methods: {
    // 啟動公告輪播
    loopAnnouncement() {
      this.bulletinTimeInterval = setInterval(() => {
        // 更新當前索引
        if (this.currentIndex < this.contents.length - 1) {
          this.currentIndex++
        } else {
          this.currentIndex = 0
        }
        // 更新輪播位置
        this.updateCarousel()
      }, this.carouselIntervalTime)
    },
    // 打開指定網址
    openWebsite(url) {
      window.open(url, '_blank')
    },
    // 更新輪播位置
    updateCarousel() {
      const text = 'translateY(' + -this.currentIndex * this.itemHeight + 'px)'
      $('.carousel').css('transform', text)
    },
    // 隱藏公告
    hideButtonClicked() {
      // 清除輪播定時器
      clearInterval(this.bulletinTimeInterval)
      // 觸發隱藏公告事件
      this.$emit('hideBulletin')
    }
  },
  // 組件銷毀時清理定時器
  destroyed() {
    if (this.bulletinTimeInterval) {
      clearInterval(this.bulletinTimeInterval)
    }
  }
}
</script>

<style scoped>

.bulletin-slide-down {
  position: relative;
}

.bulletin-slide-down-content {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 0;
  top: 0px;
  transform: translateY(0px);
  height: 60px;
  width: calc(100% - 16px);
  background: #fff;
  box-shadow: 0px 3px 30px 0px rgba(15, 1, 62, 0.0887);

  transition: all 0.5s ease-in;
  margin: 8px;
  z-index: 2;
  border-radius: 8px;
  opacity: 1;
}

.bulletin-slide-down-content.hide {
  transform: translateY(-80px);
  /* transition: all .3s ease-in-out; */
  transition: all 0s ease-in;
  opacity: 0;
}
.bulletin-title {
  display: block;
  align-self: center;
  margin-left: 16px;
  margin-right: 16px;
  width: 160px;
  max-width: 40px;
  min-width: 40px;
  height: 22px;
  border-radius: 4px;
  background: rgba(242, 150, 0, 1);
  text-align: center;
}

.bulletin-title-label {
  color: white;
  height: 22px;
  line-height: 22px;
  font-size: 14px;

}




/* styles.css */
.carousel-container {
  position: relative;
  overflow: hidden;
  height: 60px;
  width: 100%;

}

.carousel {
  display: flex;
  flex-direction: column;
  transition: transform 0.5s ease-in-out;
}

.carousel-item {
  display: flex;
  height: 60px;
  font-size: 14px;
  
  align-self: flex-start;
}

.carousel-item-label {
  align-self: center;
  max-height: 40px;
  line-height: 20px;
  font-size: 14px;
  color: rgba(112, 116, 119, 1);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  opacity: 1;
  cursor: pointer;
}

.carousel-item-label:hover {
  opacity: 0.8;
}

.hide-bulletin-button {
  height: 24px;
  width: 24px;
  align-self: center;
  margin-right: 8px;
  margin-left: 8px;
  cursor: pointer;
  opacity: 1;
}

.hide-bulletin-button:hover {
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/Bulletin.vue